
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting Micro-deposits errors.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Micro-deposits errors' subtitle='Guide to troubleshooting micro-deposits errors' mdxType="Header" />
    <h4 {...{
      "id": "bank_transfer_account_blocked"
    }}><strong parentName="h4">{`BANK_TRANSFER_ACCOUNT_BLOCKED`}</strong></h4>
    <ErrorReference type='BANK_TRANSFER_ERROR' error='BANK_TRANSFER_ACCOUNT_BLOCKED' subtitle="The bank transfer could not be completed because a previous transfer involving the same end-user account resulted in an error." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid cannot send micro-deposits to verify this account because it has flagged the account as not valid for use. This can happen if a previous micro-deposit transfer to this account resulted in an ACH return.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Ask the end user to link a different account with Plaid and re-attempt the transfer with the new account.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "bank_transfer_account_blocked",
        level: 4,
        title: "BANK_TRANSFER_ACCOUNT_BLOCKED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
